import React, { useEffect, useCallback, useState } from 'react';
import { Box, Heading, Image, Select, Button, Text } from 'grommet';
import crypto from 'crypto';
import { getCookie } from 'granite-admin/utils/storage';
import { deleteCookie } from 'granite-admin/utils/storage';
// import Spinner from 'granite-admin/core/components/Spinner';

import useQuery from 'granite-admin/utils/useQuery';
import quiversLogo from './assets/quivers.png';
import quiversLogoHeading from './assets/quivers2.png';
// import { getAuthToken } from 'granite-admin/utils/auth-singleton';

const redirectUrl = process.env.REACT_APP_KONECT_REDIRECT_BASE_URL;
const clientId = process.env.REACT_APP_CLIENT_ID;
const clientSecretKeyEnv = process.env.REACT_APP_CLIENT_SECRET_KEY;

const Initialize = () => {
  const { query } = useQuery();
  // let authToken = getAuthToken();
  const id = getCookie('id');
  const business = getCookie('business');
  // const [loading, setLoading] = useState(false);
  const { host, shop, timestamp, hmac, session, embedded } = query;
  const [newPage, setNewPage] = useState(false);
  const [enableButton, setEnableButton] = useState(false);
  const [redirectBusiness, setRedirectBusiness] = useState('');
  // const [showButton, setshowButton] = useState(false);

  function constantTimeComparison(a, b) {
    if (a?.length !== b?.length) {
      return false;
    }

    let result = 0;
    for (let i = 0; i < a.length; i++) {
      result |= a.charCodeAt(i) ^ b.charCodeAt(i);
    }
    return result === 0;
  }

  let qtuery = {
    host: host,
    shop: shop,
    timestamp: timestamp,
    hmac: hmac,
  };

  // const fetchData = useCallback(
  //   async value => {
  //     const apiUrl = `https://api.quivers${
  //       value === 'Staging' ? 'test' : value === 'Demo' ? 'demo' : ''
  //     }.com/v1/Plugins/SearchAll?searchTerm=EcommShopify&pagesize=1000&page=1`;
  //     try {
  //       const response = await fetch(apiUrl, {
  //         headers: {
  //           Authorization:
  //             value === 'Staging'
  //               ? 'apikey addkey'
  //               : value === 'Demo'
  //               ? 'apikey addkey'
  //               : 'apikey addkey',
  //         },
  //       });
  //       if (!response.ok) {
  //         throw new Error('Network response was not ok');
  //       }
  //       const data = await response.json();

  //       if (data?.result?.length > 0) {
  //         const isPresent = data.result.some(function (data) {
  //           return data?.settings?.dynamic?.clientData?.base_url.includes(shop);
  //         });

  //         setshowButton(isPresent);
  //         setEnableButton(true);
  //         setLoading(false);
  //       } else {
  //         setshowButton(false);
  //         setEnableButton(true);
  //         setLoading(false);
  //       }
  //     } catch (error) {
  //       console.log('error');
  //     }
  //   },
  //   [shop],
  // );

  const getRedirectUrl = useCallback(async () => {
    function verifyDigest(queryString) {
      const clientSecretKey = clientSecretKeyEnv;
      const { host, shop, timestamp, hmac: hmacKey } = queryString;
      const message = session
        ? `host=${host}&session=${session}&shop=${shop}&timestamp=${timestamp}`
        : `host=${host}&shop=${shop}&timestamp=${timestamp}`;
      const hmac = crypto.createHmac('sha256', clientSecretKey);
      hmac.update(message);
      const digest = hmac.digest('hex');
      return constantTimeComparison(digest, hmacKey);
    }

    if (verifyDigest(qtuery)) {
      if (id || business) {
        window.open(`${redirectUrl}shopify/app-redirect/?base_url=${shop}`, '_self');
      } else {
        setNewPage(true);
      }
    } else {
      window.open(`${redirectUrl}shopify/invalid-request`, '_self');
    }
  }, [business, id, qtuery, session, shop]);

  useEffect(() => {
    getRedirectUrl();
    setTimeout(() => {
      deleteCookie('id');
      deleteCookie('business');
    }, 60000);
  }, [getRedirectUrl]);

  if (embedded == '1') {
    return window.open(`${redirectUrl}shopify/plugin-redirect/?shop=${shop}`, '_self');
  }

  return (
    <>
      {newPage ? (
        <>
          <Box background="#213957" fill align="center" justify="center">
            <Image src={quiversLogoHeading} height="180px" width="580px" />
            <Heading level={4}>Select your environment</Heading>

            <Box direction="row">
              <Box background="white" width="100%">
                <Select
                  placeholder="Select your environment..."
                  onChange={e => {
                    setRedirectBusiness(e.value === 'Development' ? 'test' : e.value === 'Staging' ? 'demo' : '');
                    // fetchData(e.value);
                    if (e.value) setEnableButton(true);
                    // setLoading(true);
                  }}
                  options={['Development']}
                />
              </Box>
              <Button
                disabled={!enableButton}
                primary
                color={'blue'}
                label={'submit'}
                onClick={() => {
                  // if (showButton) {
                  //   window.open(`https://admin.quivers${redirectBusiness}.com/`, '_self');
                  // } else {
                  window.open(
                    `https://apollo.quivers${redirectBusiness}.com/#/choose_business?destination=app_install/EcommShopify?name=${shop}%26client_id=${clientId}`,
                    '_self',
                  );
                  //   }
                  //
                }}
              />
            </Box>
            {/* {loading && (
              <Box
                align="center"
                justify="center"
                flex
                height="100%"
                style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, background: 'rgba(0, 0, 0, 0.4)' }}
              >
                <Spinner />
                <Text>Please wait...</Text>
              </Box>
            )} */}
          </Box>
        </>
      ) : (
        <Box
          background="#213957"
          fill
          align="center"
          justify="center"
          animation={{
            type: 'fadeIn',
            delay: 0,
            duration: 3000,
          }}
        >
          <Image src={quiversLogo} height="80px" width="80px" />
          <Heading level={4}>Please wait...</Heading>
        </Box>
      )}
    </>
  );
};

export default Initialize;
